import { startTransition, useEffect, useRef, useState } from 'react'

export function useScrollDirectionNew(debounceTime = 150) {
  const [hasScrolled, setHasScrolled] = useState(false)
  const [isScrollingUp, setIsScrollingUp] = useState(false)
  const lastScrollY = useRef(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)
  // Use refs to read latest values inside the scroll handler without
  // re-registering the listener on every state change.
  const isScrollingUpRef = useRef(false)

  useEffect(() => {
    const handleScroll = () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)

      timeoutRef.current = setTimeout(() => {
        const currentScrollY = window.scrollY
        const hasScrolledNow = currentScrollY > 10
        const isScrollingUpNow = currentScrollY > lastScrollY.current

        // Use startTransition so scroll state updates are non-urgent
        // and don't block user interactions.
        startTransition(() => {
          setHasScrolled(hasScrolledNow)
          if (isScrollingUpNow !== isScrollingUpRef.current) {
            isScrollingUpRef.current = isScrollingUpNow
            setIsScrollingUp(isScrollingUpNow)
          }
        })

        lastScrollY.current = currentScrollY
      }, debounceTime)
    }

    // passive:true lets browser scroll immediately without waiting for
    // the handler to finish — critical for INP on mobile.
    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [debounceTime]) // debounceTime is the only real dependency now

  return { hasScrolled, isScrollingUp }
}
